module.exports = __webpack_public_path__ + "img/icon_weather_313.fc655706.svg";